import React from 'react';

const QualificationContent = ({qualification}) => {
    const {duration,title,description,result,inistitute}= qualification
    return (
        <div className='content relative grid grid-cols-12 gap-5  py-5'>
            <div className="col-span-3">

<h3 className='text-2xl'>{duration}</h3>

            </div>
            <div className="col-span-9">
                <h2 className='text-3xl font-bold'>{title}</h2>
                <h4 className='text-lg font-semibold mt-4 text-primary'>{inistitute}</h4>
                <h6 className='font-bold mb-2'>result : {result}</h6>
                <p className='text-secondaryWhite'>{description}</p>
            </div>
           
        </div>
    );
};

export default QualificationContent;